<script>
  import mexp from 'math-expression-evaluator';
  export let value;
  export let label;
  export let min = undefined;
  export let max = undefined;
  export let disabled = undefined;
  export let showArrows = false;
  export let evalExpr = true;

  let lastValidValue = value;
  function evalMath() {
    if (evalExpr) {
      let result = value;
      try {
        result = mexp.eval(result);
      } catch (e) {
        // sic
      }
      value = Math.floor(result);
      if (max !== undefined) {
        value = Math.min(max, result);
      }
      if (min !== undefined) {
        value = Math.max(min, result);
      }
      if (isNaN(value)) {
        value = lastValidValue;
      } else {
        lastValidValue = value;
      }
    }
  }

  function keydown(e) {
    if (showArrows) {
      if (e.key === 'ArrowUp') {
        event.preventDefault();
        value++;
      } else if (e.key === 'ArrowDown') {
        event.preventDefault();
        value--;
      }
    }
  }
</script>

<label class:disabled for="number-input"
  >{label}
  <div>
    <input
      name="number-input"
      type="text"
      on:blur={evalMath}
      on:keydown={keydown}
      bind:value
      autocomplete="off"
      {min}
      {max}
      {disabled}
    />
    {#if showArrows}
      <button class="arrow top" type="button" on:click={() => value++}>▲</button
      >
      <button class="arrow bottom" type="button" on:click={() => value--}
        >▼</button
      >
    {/if}
  </div>
</label>

<style>
  label > div {
    display: flex;
    position: relative;
  }

  button.arrow {
    position: absolute;
    right: 0;
    margin: 0;
    padding: 0;
    margin-right: 2px;
    padding-left: 2px;
    padding-right: 2px;
  }

  .top {
    top: 4px;
  }

  .bottom {
    bottom: 8px;
  }

  input {
    margin: 4px 0 0.5em 0;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 10px 8px;
    background-color: white;
    border: 1px solid transparent;
    display: block;
    width: 100%;
    font-size: 16px;
  }

  label.disabled,
  input:disabled {
    color: #ccc;
  }

  input:not(:disabled):hover {
    border: 1px solid var(--color-4);
    cursor: pointer;
  }
</style>
